import { getAppVersion } from '@nibfe/mkt-env-api';
import dayjs from 'dayjs';
export const getAppVersionName = () => {
    try {
        return getAppVersion() || '12.42.200';
    }
    catch (error) {
        return '12.42.200';
    }
};
export const convertTimestampToDate = (timestamp) => {
    const date = dayjs(timestamp);
    return date.format('YYYY-MM-DD');
};
